// extracted by css-extract-rspack-plugin
export default {"container":"PlanTypeSegmentedControl-module__container__kXhIsQm","segment":"PlanTypeSegmentedControl-module__segment__m7VK7nL"};